import script from "./ga3SunsetWarning.vue?vue&type=script&setup=true&lang=js"
export * from "./ga3SunsetWarning.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__